import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import loginLogo from "../../assets/img/login-Logo.png";
// import loginImage from "../../assets/img/woman.png";
import { FaRegEyeSlash } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import { GrFormNextLink } from "react-icons/gr";
import { MdVerified } from "react-icons/md";
import OtpInput from "react-otp-input";
import Left_section from "../../assets/img/Left3.png";
import { useTranslation } from "react-i18next";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
import "../../assets/css/Login_1.css";
// import Otp_field from "../ui/Otp_field";
import axios from "axios";
import Footer from "../Footer/Footer";
// import Otp_field from "../ui/Otp_field.js";
const Login_1 = () => {
  // const [mode, setMode] = useState("login");
  const queryParams = new URLSearchParams(window.location.search);
  const defaultMode = queryParams.get("mode") || "login";

  const [mode, setMode] = useState(defaultMode);
  const { t } = useTranslation();
  // Add this state for email/phone toggle in forgot password modal
  const [isEmailMode, setIsEmailMode] = useState(true);

  // Handler for sending OTP in forgot password modal
  const handleSend = async () => {
    try {
      if (isEmailMode) {
        if (!phoneNumber || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(phoneNumber)) {
          alert("Please enter a valid email address");
          return;
        }
        await axios.post("https://network.rentel.in/email/send-email", {
          email: phoneNumber,
        });
      } else {
        if (!phoneNumber || !/^[6-9]\d{9}$/.test(phoneNumber)) {
          alert("Please enter a valid 10-digit mobile number");
          return;
        }
      }
      setStep("otp");
      setTimer(300);
      setResendVisible(false);
      // alert("OTP sent successfully");
    } catch (err) {
      alert(
        "Failed to send OTP: " + (err.response?.data?.message || err.message)
      );
    }
  };
  const [activeTab, setActiveTab] = useState("email");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(""); // ✅ first declare state (fixed setter name)
  const isEmail = phoneNumber.includes("@"); // ✅ then derive based on its current value
  // can be email or mobile
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [lastName, setlastName] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [timer, setTimer] = useState(300); // 5 minutes = 300 seconds
  const [resendVisible, setResendVisible] = useState(false);
  const [serverError, setServerError] = useState("");
  const [emailOtp, setEmailOtp] = useState(["", "", "", ""]);
  const [mobileOtp, setMobileOtp] = useState(["", "", "", ""]);
  const [showEmailOtp, setShowEmailOtp] = useState(false);
  const [showMobileOtp, setShowMobileOtp] = useState(false);
  const [otpStatus, setOtpStatus] = useState(null); // null | "success" | "error"
  const [isOtpValid, setIsOtpValid] = useState(null); // true | false | null
  const [otpError, setOtpError] = useState(""); // for "Invalid OTP"
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [mobileNumberVerified, setMobileNumberVerified] = useState(false);
  const [emailAddressVerified, setEmailAddressVerified] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [signupStep, setSignupStep] = useState(1);
  const [emailOrPhone, setEmailOrPhone] = useState("");

  /// type assign variable
  const [otpType, setOtpType] = useState("");

  // Signup OTP flow
  const [showSignupOtp, setShowSignupOtp] = useState(false);
  const [signupOtp, setSignupOtp] = useState(["", "", "", "", "", ""]);
  const [signupOtpTimer, setSignupOtpTimer] = useState(300);
  const [pendingSignupPayload, setPendingSignupPayload] = useState(null);
  const [signupOtpError, setSignupOtpError] = useState("");
  const [contact, setContact] = useState(""); // email or mobile

  const [errors, setErrors] = useState({
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    fullName: "",
    lastName: "",
  });
  const [step, setStep] = useState("password"); // "password", "otp", "newpassword"
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // 6-digit OTP

  useEffect(() => {
    const token = localStorage.getItem("token");
    // console.log("Token from localStorage:", token); // ✅ Debug log

    if (token && token !== "undefined" && token !== "null") {
      navigate("/");
    }
  }, [navigate]);

  const validate = () => {
    const newErrors = {
      email: "",
      mobile: "",
      password: "",
      confirmPassword: "",
      fullName: "",
      lastName: "",
    };


    if (mode === "signup") {
      if (!fullName.trim()) newErrors.fullName = "Please enter your first name";
      if (!lastName.trim()) newErrors.lastName = "Please enter your last name";

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^[6-9]\d{9}$/;

      if (!contact.trim()) {
        newErrors.contact = "Enter email or phone number";
      } else if (!emailRegex.test(contact) && !mobileRegex.test(contact)) {
        newErrors.contact = "Enter valid email or 10-digit phone";
      }

      if (!password.trim() || password.length < 6) {
        newErrors.password = !password.trim()
          ? "Please enter password"
          : "Password must be at least 6 characters";
      }

      if (!confirmPassword.trim()) {
        newErrors.confirmPassword = "Please confirm your password";
      } else if (password !== confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
      }
    }

    if (mode === "login") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^[6-9]\d{9}$/;

      if (!contact.trim()) {
        newErrors.contact = "Enter email or phone number";
      } else if (!emailRegex.test(contact) && !mobileRegex.test(contact)) {
        newErrors.contact = "Invalid email or phone number";
      }

      if (!password.trim()) {
        newErrors.password = "Please enter password";
      }
    }


    setErrors(newErrors);
    return Object.values(newErrors).every((err) => err === "");
  };

  const handleSubmit = async () => {
    const isValid = validate();
    if (!isValid) {
      // Validation failed, errors are already set by validate()
      return;
    }

    if (mode === "signup") {
      // Check if email is verified
      if (!isEmailVerified) {
        alert("Please verify your email address before signing up");
        return;
      }

      const payload = {
        name: fullName,
        lastName: lastName,
        email,
        phoneNumber: mobile,
        password,
        confirmPassword,
      };

      setLoading(true);
      const sent = await handleSendOTP(email);
      setLoading(false);

      if (sent) {
        setPendingSignupPayload(payload);
        setSignupOtp(["", "", "", "", "", ""]);
        setSignupOtpError("");
        setSignupOtpTimer(300);
        setShowSignupOtp(true);
      }
      return;
    }

    await handleLogin();
  };
  const handleLogin = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        "https://network.rentel.in/users/login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: contact.includes("@") ? contact : undefined,
            phoneNumber: /^[6-9]\d{9}$/.test(contact) ? contact : undefined,
            password,
          }),
        }
      );

      const data = await response.json();

      // ❌ LOGIN FAILED
      if (!response.ok) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^[6-9]\d{9}$/;

        // 👉 email / phone format wrong
        if (!emailRegex.test(contact) && !mobileRegex.test(contact)) {
          setErrors({
            contact: "Invalid email or phone number",
            password: "",
          });
        }
        // 👉 email format sacho chhe → password khotu manvu
        else {
          setErrors({
            contact: "",
            password: "Invalid password",
          });
        }
        return;
      }
      // ✅ SUCCESS
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.userInfo));
      navigate("/");
    } catch (error) {
      setErrors({
        contact: "Server error. Please try again",
        password: "",
      });
    } finally {
      setLoading(false);
    }
  };



  const completeSignup = async (payload) => {
    setLoading(true);

    try {
      const url = "https://network.rentel.in/users/signup";

      // console.log("Sending payload:", payload);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        setServerError(data.message || "Something went wrong");
        return;
      }

      setShowSignupOtp(false);
      setPendingSignupPayload(null);
      setMode("login"); // 🚀 go directly to login page after OTP verification
      setActiveTab("email");
    } catch (error) {
      console.error("Error during signup/login:", error);
      alert("Failed to connect to server.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "signup") {
      setActiveTab("email");
    }
  }, [mode]);

  // Signup OTP countdown
  useEffect(() => {
    if (!showSignupOtp) return;
    const interval = setInterval(() => {
      setSignupOtpTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [showSignupOtp]);

  // OTP Handling===========================================
  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (!/^[0-9]?$/.test(value)) return; // only allow single digit

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // move to next input if digit entered
    if (value && index < 3) {
      const nextInput = document.querySelectorAll(".otp-box")[index + 1];
      nextInput?.focus();
    }
  };

  const handleOtpSubmit = async (email, otpArray) => {
    const enteredOtp = otpArray.join("");
    // console.log("Entered OTP:", enteredOtp);

    if (enteredOtp.length !== 6) {
      alert("Enter full OTP");
      setOtpStatus("error");
      return false;
    }

    const payload = { email, otp: enteredOtp };
    const endpoint = "https://network.rentel.in/email/verify-otp";

    try {
      const res = await axios.post(endpoint, payload);
      if (res.data.message === "OTP verified successfully") {
        // ✅ Email OTP success
        setOtpStatus("success");
        setIsEmailVerified(true);
        setShowEmailOtp(false);
        return true;
      } else {
        setOtpStatus("error");
        return false;
      }
    } catch (err) {
      console.error("OTP verification error:", err);
      setOtpStatus("error");
      return false;
    }
  };

  const handleNewPasswordSubmit = async () => {
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        "https://network.rentel.in/users/forgot-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email, // ✅ sirf email maathi reset
            newPassword: newPassword,
          }),
        }
      );

      const data = await res.json();
      // console.log("API Response:", res.status, data);

      if (res.ok) {
        // alert("Password changed successfully");
        setShowForgotModal(false);
      } else {
        alert(data?.message || `Error ${res.status}: Password change failed`);
      }
    } catch (error) {
      console.error("Network error:", error);
      alert("Network error");
    } finally {
      setLoading(false);
    }
  };

  // Countdown effect
  useEffect(() => {
    if (step === "otp" && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (timer === 0) {
      setResendVisible(true);
    }
  }, [step, timer]);

  const handleResendOtp = async () => {
    try {
      const payload = { email };
      await axios.post("https://network.rentel.in/email/send-email", payload);

      setTimer(300); // reset timer
      setResendVisible(false);
    } catch (err) {
      console.error(err);
      alert("Failed to resend OTP");
    }
  };

  // Signup OTP handlers
  const handleSignupOtpChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;
    const updated = [...signupOtp];
    updated[index] = value;
    setSignupOtp(updated);
  };

  const handleSignupOtpResend = async () => {
    const sent = await handleSendOTP(email);
    if (sent) {
      setSignupOtp(["", "", "", "", "", ""]);
      setSignupOtpError("");
      setSignupOtpTimer(300);
    }
  };

  const handleSignupOtpConfirm = async () => {
    setSignupOtpError("");
    const isValid = await handleOtpSubmit(email, signupOtp);
    if (!isValid) {
      setSignupOtpError("Invalid OTP. Please try again.");
      return;
    }

    if (pendingSignupPayload) {
      await completeSignup(pendingSignupPayload);
    }
  };

  // Verify mobile or email OTP\

  const handleEmailOtp = async () => {
    const isSended = await handleOtpSubmit(email, emailOtp);

    if (isSended) {
      setIsEmailVerified(true);
      setShowEmailOtp(false);

      // ⭐ NOW safely do SIGNUP
      const payload = {
        name: fullName,
        lastName: lastName,
        email,
        phoneNumber: mobile,
        password,
      };

      // Call your signup API here
      await completeSignup(payload);

    } else {
      setOtpStatus("error");
      setEmailError("Invalid OTP");
      alert("Failed to verify email OTP");
    }
  };


  const handleEmailForgotOtp = async () => {
    const isSended = await handleOtpSubmit(email, otp);
    if (isSended) {
      setStep("newpassword");
    } else {
      alert("Failed to verify email OTP");
    }
  };

  const handleEmailVerifyClick = async () => {
    const isSended = await handleSendOTP(email);
    if (isSended) {
      setShowEmailOtp(true);
      setEmailError("");
    } else {
      setEmailError("Failed to send OTP");
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleForgotEmail = async () => {
    if (!isValidEmail(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }
    setEmailError("");

    const isSended = await handleSendOTP(email);

    if (isSended) {
      setStep("otp");
      setTimer(300);
      setResendVisible(false);
    } else {
      setEmailError("Failed to send OTP. Please try again.");
    }
  };

  const handleSendOTP = async (email) => {
    if (!email.trim()) {
      setEmailError("Please enter an email address");
      return false;
    }

    const payload = { email };

    const endpoint = "https://network.rentel.in/email/send-email";

    try {
      const res = await axios.post(endpoint, payload);
      // console.log(res);

      if (res.data.message?.toLowerCase().includes("otp sent")) {
        setEmailError(""); // ✅ Clear error if success
        // setShowEmailOtp(true); // 👉 show OTP input modal if required
        return true;
      } else {
        alert("Failed to send OTP: " + res.data.message);
        return false;
      }
    } catch (err) {
      console.error("Error sending OTP:", err);

      if (err.response?.data?.message === "Email already exists") {
        setEmailError("Email Address Already Exists");
      } else {
        alert(
          "Error sending OTP: " + (err.response?.data?.message || err.message)
        );
      }
      return false;
    }
  };

  // Countdown effect for OTP
  useEffect(() => {
    let interval;
    if (showEmailOtp && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1; // ✅ subtract 1, not 2
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showEmailOtp]);

  const formatTime = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleSignupClick = () => {
    if (signupStep === 1) {
      // First click → Send OTP
      handleEmailVerifyClick();
      setSignupStep(2); // next time submit
    } else {
      // Second click → Complete signup
      handleSubmit();
    }
  };


  return (
    <>
      <NoZoomWrapper>
        <NoCopyWrapper>
          <div className="login-container">
            {/* Left Side */}
            <div className="login-left">
              <img src={Left_section} alt="Login" className="left-imga" />
              {/* <img src={loginImage} alt="Login" className="left-image" /> */}
            </div>

            {/* Right Side */}
            <div className="login-right">
              <div className="auth-card">
                <div className="brand-header">
                  <img src={loginLogo} alt="Rentel Logo" className="logonama" />
                  <p className="brand-tagline">Rent Smarter, Live Better</p>
                </div>

                <div className="welcome-copy">
                  <h2 className="welcome-title">Welcome!</h2>
                  <p className="welcome-subtitle">
                    Welcome Back, You've Been Missed!
                  </p>
                </div>

                <div className="pill-toggle">
                  <button
                    className={`pill ${mode === "signup" ? "active" : ""}`}
                    onClick={() => setMode("signup")}
                  >
                    {t("signUp")}
                  </button>
                  <button
                    className={`pill ${mode === "login" ? "active" : ""}`}
                    onClick={() => setMode("login")}
                  >
                    {t("login")}
                  </button>
                </div>

                {/* {mode === "login" && (
                  <div className="toggle-buttons secondary">
                    <button
                      className={activeTab === "email" ? "active" : "inactive"}
                      onClick={() => setActiveTab("email")}
                    >
                      {t("email")}
                    </button>
                    <button
                      className={
                        activeTab === "mobile" ? "active" : "inactive"
                      }
                      onClick={() => setActiveTab("mobile")}
                    >
                      {t("mobileNumber")}
                    </button>
                  </div>
                )} */}

                <div className="form-wrapper wide">
                  {mode === "signup" ? (
                    <>
                      <div className="dual-row">

                        {/* FIRST NAME */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            placeholder="First Name"
                            className={`inpute-fielde ${errors.fullName ? "error-input" : ""}`}
                            value={fullName}
                            onChange={(e) => {
                              setFullName(e.target.value);
                              if (errors.fullName) {
                                setErrors((prev) => ({ ...prev, fullName: "" }));
                              }
                            }}
                            onFocus={() => {
                              if (errors.fullName) {
                                setErrors((prev) => ({ ...prev, fullName: "" }));
                              }
                            }}
                          />

                          {errors.fullName && (
                            <p className="error-text">{errors.fullName}</p>
                          )}
                        </div>

                        {/* LAST NAME */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            placeholder="Last Name"
                            className={`inpute-fielde ${errors.lastName ? "error-input" : ""}`}
                            value={lastName}
                            onChange={(e) => {
                              setlastName(e.target.value);
                              if (errors.lastName) {
                                setErrors((prev) => ({ ...prev, lastName: "" }));
                              }
                            }}
                            onFocus={() => {
                              if (errors.lastName) {
                                setErrors((prev) => ({ ...prev, lastName: "" }));
                              }
                            }}
                          />

                          {errors.lastName && (
                            <p className="error-text">{errors.lastName}</p>
                          )}
                        </div>

                      </div>

                      <div className="field-with-verify">
                        <input
                          className={`inpute-fielde ${errors.email ? "error-input" : ""
                            }`}
                          type="email"
                          placeholder={t("email")}
                          value={email}
                          onChange={(e) => {
                            const newVal = e.target.value;
                            setEmail(newVal);

                            if (isEmailVerified && newVal !== email) {
                              setIsEmailVerified(false);
                            }

                            if (errors.email) {
                              setErrors((prev) => ({ ...prev, email: "" }));
                            }
                          }}
                          onFocus={() => {
                            if (errors.email) {
                              setErrors((prev) => ({ ...prev, email: "" }));
                            }
                          }}
                        />
                      </div>
                      {errors.email && (
                        <div className="error-text">{errors.email}</div>
                      )}

                      {showEmailOtp && (
                        <div className="otp-modal-overlay">
                          <div className="otp-modal">
                            <h3>Enter OTP</h3>

                            <div className={`box-otp ${otpStatus}`}>
                              <div className="otp-controls">
                                <OtpInput
                                  numInputs={6}
                                  otpType="number"
                                  isInputNum={true}
                                  value={emailOtp.join("")}
                                  onChange={(otp) => {
                                    setEmailOtp(otp.split(""));
                                    setOtpStatus(null);
                                  }}
                                  containerStyle={{
                                    display: "flex",
                                    gap: "20px",
                                  }}
                                  renderInput={(props, index) => (
                                    <input
                                      key={index}
                                      {...props}
                                      className="otp-input"
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        textAlign: "center",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "10px",
                                        backgroundColor: "#f9f9f9",
                                      }}
                                    />
                                  )}
                                />

                                <button className="submit-btn" onClick={handleEmailOtp}>
                                  <GrFormNextLink />
                                </button>
                              </div>
                            </div>

                            <span className="timer">{formatTime(timer)}</span>

                            <button className="close-btn" onClick={() => setShowEmailOtp(false)}>
                              Close
                            </button>
                          </div>
                        </div>
                      )}


                      <div className="field-with-verify">
                        <input
                          className={`inpute-fielde ${errors.mobile ? "error-input" : ""
                            }`}
                          type="tel"
                          placeholder={t("Whatsapp Number")}
                          value={mobile}
                          onChange={(e) => {
                            const newVal = e.target.value.replace(/\D/g, "");
                            setMobile(newVal);

                            if (errors.mobile) {
                              setErrors((prev) => ({ ...prev, mobile: "" }));
                            }
                          }}
                          onFocus={() => {
                            if (errors.mobile !== "") {
                              setErrors((prev) => ({ ...prev, mobile: "" }));
                            }
                          }}
                          maxLength={10}
                        />
                      </div>
                      {errors.mobile && (
                        <div className="error-text">{errors.mobile}</div>
                      )}


                    </>
                  ) : (
                    <div className="form-group">
                      <input
                        className={`inpute-fielde ${errors.contact ? "error-input" : ""}`}
                        type="text"
                        placeholder="Email / Whatsapp Number"
                        value={contact}
                        onChange={(e) => {
                          setContact(e.target.value);

                          // ✅ user edited email → clear ONLY email error
                          if (errors.contact) {
                            setErrors((prev) => ({ ...prev, contact: "" }));
                          }
                        }}
                        onFocus={() => {
                          if (errors.contact) {
                            setErrors((prev) => ({ ...prev, contact: "" }));
                          }
                        }}
                      />

                      {errors.contact && (
                        <div className="error-text">{errors.contact}</div>
                      )}
                    </div>

                  )}

                  <div className="form-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder={t("password")}
                      className={`inpute-fielde ${errors.password ? "error-input" : ""}`}
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);

                        // ✅ user edited password → clear ONLY password error
                        if (errors.password) {
                          setErrors((prev) => ({ ...prev, password: "" }));
                        }
                      }}
                      onFocus={() => {
                        if (errors.password) {
                          setErrors((prev) => ({ ...prev, password: "" }));
                        }
                      }}
                    />

                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="toggle-password-visibility"
                    >
                      {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                    </span>

                    {errors.password && (
                      <p className="error-text">{errors.password}</p>
                    )}
                  </div>






                  {mode === "signup" && (
                    <div className="form-group">
                      <input
                        type={showConfirm ? "text" : "password"}
                        placeholder="Confirm Password"
                        className={`inpute-fielde ${errors.confirmPassword ? "error-input" : ""
                          }`}
                        value={confirmPassword}
                        onChange={(e) => {
                          setConfirmPassword(e.target.value);
                          if (errors.confirmPassword) {
                            setErrors((prev) => ({ ...prev, confirmPassword: "" }));
                          }
                        }}
                        onFocus={() => {
                          if (errors.confirmPassword) {
                            setErrors((prev) => ({ ...prev, confirmPassword: "" }));
                          }
                        }}
                      />
                      <span
                        onClick={() => setShowConfirm(!showConfirm)}
                        className="toggle-password-visibility"
                      >
                        {showConfirm ? <FaRegEye /> : <FaRegEyeSlash />}
                      </span>

                      {errors.confirmPassword && (
                        <p className="error-text">{errors.confirmPassword}</p>
                      )}
                    </div>
                  )}

                  {serverError && (
                    <p className="error-text" style={{ textAlign: "center" }}>
                      {serverError}
                    </p>
                  )}

                  {mode === "login" && (
                    <h5
                      className="passwords"
                      onClick={() => setShowForgotModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      {t("forgotPassword")}
                    </h5>
                  )}


                  <button
                    className="login-button"
                    onClick={handleSignupClick}
                    disabled={loading}
                  >
                    {loading
                      ? t("pleaseWait")
                      : mode === "login"
                        ? t("login")
                        : t("signup")  // always show Signup
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Forgot Password Modal */}
          {showForgotModal && (
            <div
              className="modal-overlay"
              onClick={() => setShowForgotModal(false)}
            >
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Step 1: Email input only */}
                {step === "password" && (
                  <>
                    <h2 style={{ color: "#e50914" }}> {t("forgotPassword")}</h2>
                    <p>{t("sendNotification")}</p> {/* Email Input */}
                    <input
                      type="email"
                      placeholder={t("email")}
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      style={{
                        border: emailError ? "1px solid red" : "1px solid #ccc",
                        backgroundColor: emailError ? "#ffecec" : "#fff", // light pink if error
                        padding: "8px",
                        borderRadius: "4px",
                        width: "100%",
                        outline: "none",
                      }}
                    />
                    {/* Error text */}
                    {emailError && (
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                        }}
                      >
                        {emailError}
                      </p>
                    )}
                    <button
                      onClick={() => {
                        if (!phoneNumber) {
                          setEmailError("Please enter email address");
                          return;
                        }
                        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(phoneNumber)) {
                          setEmailError("Please enter a valid email address");
                          return;
                        }

                        setEmailError(""); // ✅ clear error if valid
                        handleForgotEmail();
                      }}
                      disabled={loading}
                    >
                      {t("send")}
                    </button>
                  </>
                )}

                {/* Step 2: OTP Verification */}
                {step === "otp" && (
                  <>
                    <h2 style={{ color: "#e50914" }}>{t("otpVerification")}</h2>
                    <p>
                      {t("enterVerificationCode")} email {phoneNumber}
                    </p>

                    <div className="otp-input-group">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength="1"
                          value={digit}
                          onChange={(e) => handleOtpChange(e, index)}
                          className="otp-box"
                          disabled={loading}
                        />
                      ))}
                    </div>

                    <p style={{ marginTop: "10px" }}>
                      {resendVisible ? (
                        <span
                          style={{ color: "blue", cursor: "pointer" }}
                          onClick={handleResendOtp}
                        >
                          {t("resendOtp")}
                        </span>
                      ) : (
                        <span>
                          {t("resendAvailableIn")} {Math.floor(timer / 60)}:
                          {String(timer % 60).padStart(2, "0")}
                        </span>
                      )}
                    </p>

                    <button
                      onClick={handleEmailForgotOtp} // 👈 only email handler
                      disabled={loading || otp.some((d) => d === "")}
                    >
                      {t("Submit OTP")}
                    </button>
                  </>
                )}

                {/* Step 3: Set New Password */}
                {step === "newpassword" && (
                  <>
                    <h2>{t("setNewPassword")}</h2>
                    <div className="form-group">
                      <label className="form-label">{t("newPassword")}</label>
                      <input
                        type={showNew ? "text" : "password"}
                        placeholder={t("newPassword")}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <span
                        onClick={() => setShowNew(!showNew)}
                        className="toggle-password-visibility"
                      >
                        {showNew ? <FaRegEye /> : <FaRegEyeSlash />}
                      </span>
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        {t("reEnterPassword")}
                      </label>
                      <input
                        type={showConfirm ? "text" : "password"}
                        placeholder={t("reEnterPasswordPlaceholder")}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <span
                        onClick={() => setShowConfirm(!showConfirm)}
                        className="toggle-password-visibility"
                      >
                        {showConfirm ? <FaRegEye /> : <FaRegEyeSlash />}
                      </span>
                    </div>
                    <button onClick={handleNewPasswordSubmit}>
                      {t("resetPassword")}
                    </button>
                  </>
                )}
              </div>
            </div>
          )}

          {/* <Footer /> */}
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};
export default Login_1;